import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tab, Tabs, Breadcrumb, Spinner } from 'react-bootstrap';

import moment from 'moment';
import Messages from './Messages/';
import CarePlan from './CarePlan/';
import HPIQuestions from './HPIQuestions/';
import ProviderNotes from './ProviderNotes/';
import UploadedImages from './UploadedImages/';
import EndAppointment from './EndAppointment/';
import RenderProfilePicture from '../../../_helpers/profile-picture';
import withSocketService from './withSocketService';

class View extends Component {
  render() {    
    const { telehealth, online } = this.props;

    if (!telehealth) {
      return <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>;
    }

    return <div className="row">

      {telehealth.eventId &&
        <Breadcrumb className="col-12">
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/events" }}>Events</Breadcrumb.Item>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/events/${telehealth.eventId}/details` }}>Event Details</Breadcrumb.Item>
          <Breadcrumb.Item active>View Telehealth</Breadcrumb.Item>
        </Breadcrumb>}

      {!telehealth.eventId &&
        <Breadcrumb className="col-12">
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/telehealth" }}>Telehealth</Breadcrumb.Item>
          <Breadcrumb.Item active>View Telehealth</Breadcrumb.Item>
        </Breadcrumb>}

      <div className="col-12">
        <div className="card axs-shadow">
          <div className="card-body">
            <div className="row">
              <div className="col-sm-4 my-auto">
                <div className="media">
                  <RenderProfilePicture image={telehealth.userProfile.profile} circle cached={false} width={50} height={50} className='m-auto' />
                  <div className="media-body ml-3">
                    <h5 className="m0-0">{`${telehealth.userProfile.firstName} ${telehealth.userProfile.lastName}`}</h5>
                    <span className="text-muted">{telehealth.userProfile.gender === 'm' ? 'Male' : 'Female'}, {moment(telehealth.userProfile.dateOfBirth).format('L')}</span>
                  </div>
                </div>
              </div>

              <div className="col-sm-5">
                <strong>{telehealth.questionnaire.resource.title}</strong><br />
                <strong>Date:</strong> {moment(telehealth.appointmentDate.date).format('MM/DD/YYYY hh:mm A')}<br />
                <strong>Type:</strong> {telehealth.telemedicineType === 'video' ? 'Real-Time Video' : 'Asynchronous'}
              </div>

              <div className="col-lg-2 text-center my-auto">
                {telehealth.status === 'READY' && <EndAppointment telehealthId={telehealth.id} />}

                {telehealth.status !== 'READY' &&
                  <div className="alert alert-warning text-center m-0" role="alert">{telehealth.status}</div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Current Condition */}
      <div className="col-sm mt-3">
        <h5 className="mb-3">Current Condition</h5>

        <div className="card axs-shadow">
          <div className="card-body">
            <Tabs defaultActiveKey="summary" id="uncontrolled-tab-example">
              <Tab eventKey="summary" title="Summary" className="pt-3">
                <HPIQuestions
                  questions={telehealth.questionnaire.resource.item}
                  answers={telehealth.questionnaireResponse.resource.item} />
              </Tab>
              {telehealth.questionnaireResponse &&
                <Tab eventKey="hpi" title="HPI" className='pt-3'>
                  <div>{telehealth.questionnaireResponse.hpi || <div className='text-center'>No HPI Available</div>}</div>
                </Tab>
              }
            </Tabs>
          </div>
        </div>

        <UploadedImages
          questions={telehealth.questionnaire.resource.item}
          answers={telehealth.questionnaireResponse.resource.item} />

        <div className="card axs-shadow mt-3">
          <div className="card-header">
            <h6>Provider Notes</h6>
          </div>
          <div className="card-body">
            <p className="text-center">Text in this area does not surface to patient.</p>
            <ProviderNotes telehealth={telehealth} />
          </div>
        </div>
      </div>

      {/* Messages */}
      <div className="col mt-3">
        <h5 className="mb-3">Messages</h5>

        <Messages
          online={online}
          isTyping={this.props.isTyping}
          telehealth={telehealth}
        />

        { this.props.currentUser.UserType.Name === 'Licensed' &&
          <CarePlan telehealth={telehealth} />
        }

      </div>
    </div>
  }
}

export default withSocketService(View)